


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { InstallmentModel, InteractionModel } from '@/app/shared/models';
import DataTableInstallmentsSimple from '@/app/shared/components/data-tables/installments-simple.vue';
@Component({ components: { DataTableInstallmentsSimple } })
export default class DialogGenerateInstallmentComponent extends Vue {
  @Prop(Array) readonly data!: InstallmentModel[];

  private installmentList: InstallmentModel[] = [];
  private loading = false;
  private dialog = false;
  private valueTab = '';

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }

  private async generateInstallment() {
    // if (
    //   this.installmentList.some((installment) =>
    //     this.refs
    //       .moment(installment.OriginalDueDate, 'YYYY-MM-DD')
    //       .isSameOrAfter()
    //   )
    // ) {
    //   this.$toast.error(this.$t('toasts.retroactive_salary_not_allowed'));
    //   return;
    // }
    this.loading = true;
    const promises: Promise<void>[] = [];
    await this.installmentList.forEach((installment) => {
      promises.push(
        this.refs.modules.contract.createInstallment({
          contractId: this.refs.modules.contract.contract.Id,
          installment,
        })
      );
    });
    Promise.all(promises)
      .then(async () => {
        this.refs.modules.ticket.SET_EDIT_INSTALLMENT_GENERATE(true);
        this.refs.modules.ticket
          .createInteraction(
            new InteractionModel(
              this.$t('action_code.ac8'),
              this.$t('action_desc.ad10') +
                (this.valueTab ? ' (' + this.valueTab + ')' : '')
            )
          )
          .then(() => {
            localStorage.removeItem('tabulacao');
            this.$bus.$emit('cleanValueTab');
          });
        await this.refs.modules.contract.loadInstallmentList(
          this.$route.params.id
        );
        this.$toast(this.$t('toasts.generate_installment_successfully'));
        this.dialog = false;
      })
      .catch((err) => {
        this.$toast.error('ERROR ? ', err);
        this.$toast.error(this.$t('toasts.generate_installment_error'));
      })
      .finally(() => (this.loading = false));
  }

  @Watch('dialog')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value) {
      const installmentLast = this.refs._.maxBy(
        this.refs.modules.contract.installmentList,
        'Number'
      );
      this.installmentList = this.refs._.map(this.data, (installment) => {
        return {
          Id: this.refs.util.generateGuid(),
          Status: this.refs.enums.InstallmentStatus.Generated,
          OriginalDueDate: this.refs.moment().format('YYYY-MM-DD'),
          Reference: {
            Year:
              installmentLast?.Reference?.Year ||
              installmentLast?.YearReference,
            Month:
              (installmentLast?.Reference?.Month ||
                installmentLast?.MonthReference ||
                0) + 1,
          },
          Value: installmentLast?.Value,
          OurCode: installment.OurCode,
          Number: installmentLast?.Number ? installmentLast.Number + 1 : 0,
          InstallmentType: installment.InstallmentType,
        };
      });
    }
  }
}
